<template>
    <div class="column_center_center"
        style="width: 100vw; height: 100vh; background-color: rgba(0, 0, 0, 0.7); position: fixed; top: 0; left: 0; right: 0; bottom: 0;">
        <div class="column_center_start address_picker_container">
            <div class="column_center_start" style="width: 100%;">
                <text class="title" style="color: #FD5001; font-size: 20px; margin-bottom: 30px;">選擇常用地址</text>
                <div v-for="(addressData, addressIndex) in getAddresses" :key="addressIndex"
                    class="row_center_start address"
                    @click="selectAddress(addressIndex)">
                    <div class="picker" :class="{ selected: selectedIndex === addressIndex}"></div>
                    <text class="address-text">
                        <span v-if="addressData.is_default === 1" style="color: #FD5001; margin-right: 3px;">(預設)</span>
                        {{ addressData.postcode }}{{ getCityName(addressData.city_id) }}
                        {{ getCityAreaName(addressData.cityarea_id) }}{{ addressData.address }}
                    </text>
                </div>
                <text>欲新增地址，請至<span style="color: #FD5001">會員資訊</span>頁面</text>

            </div>
            <div class="row_center_between" style="width: 100%; margin-top: 30px;">
                <button @click="close" class="cancel_button">返回</button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    data() {
        return {
            selectedIndex: null,
        }
    },
    mounted() {
        // 如果有預設的地址 找出他在 getAddresses 中的 index 並且設定 selectedIndex
        const defaultAddressData = this.getDefaultAddressData;
        if (defaultAddressData.id && this.getSelectedAddressData == null) {
            const index = this.getAddresses.findIndex((address) => {
                return address.id === defaultAddressData.id
            })
            this.selectedIndex = index;
        }
        // 如果有選擇過的地址 找出他在 getAddresses 中的 index 並且設定 selectedIndex
        if (this.getSelectedAddressData !== null) {
            const index = this.getAddresses.findIndex((address) => {
                return address.id === this.getSelectedAddressData.id
            })
            this.selectedIndex = index;
        }
    },
    computed: {
        ...mapState('basic', {
            getSelectedAddressData: 'selectedAddressData',
            currentStore: 'currentStore',
            cities: 'cities',
            cityAreas: 'cityAreas',
        }),
        ...mapState('userData', {
            memberInfo: 'memberInfo',
        }),
        getDefaultAddressData() {
            const addresses = this.getAddresses;
            if (!addresses.length) {
                return {}
            }
            for (const address of addresses) {
                if (address.is_default === 1) {
                    return address;
                }
            }
            return {}
        },
        getAddresses() {
            return this.memberInfo.addresses || []
        }
    },
    methods: {
        getCityName(cityId) {
            const city = this.cities.find((city) => {
                return city.id == cityId
            })
            return city.name
        },
        getCityAreaName(cityAreaId) {
            const cityArea = this.cityAreas.find((cityArea) => {
                return cityArea.id == cityAreaId
            })
            return cityArea.name
        },
        close() {
            event.preventDefault()
            this.$emit('close')
        },
        selectAddress(index) {
            this.selectedIndex = index
            this.$store.commit("basic/setSelectedAddressData", this.getAddresses[index])
        }
    }
}
</script>
<style lang="scss">
.address_picker_container {
    width: 94vw;
    padding: 30px 0 0;
    background-color: #fff;
    border-radius: 8px;
    font-size: 18px;
    font-weight: 400;
    font-family: PingFang SC;
    color: #000;

    .picker {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #AAAAAA;
        margin-right: 10px;
        flex-shrink: 0;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .picker.selected {
        border-color: #FACB00;
        border-width: 2px;
    }

    .picker.selected::before {
        content: '';
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #FACB00;
    }

    .address {
        width: 80%;
        padding-bottom: 20px;
        margin-bottom: 20px;
        border-bottom: 1px dotted #000;
        cursor: pointer;
        user-select: none;
    }

    .address-text {
        cursor: pointer;
    }


    .cancel_button {
        border-radius: 0 0 8px 8px;
        background-color: #EEEEEE;
        width: 100%;
        height: 56px;
        border: none;
        font-size: 20px;
        font-weight: 500;
        font-family: PingFang SC;
        color: #000;
    }

}
</style>